import React,{useState,useEffect,useRef} from "react";
import {Link,useNavigate} from "react-router-dom";
import Select from "react-select";
import { all_routes } from "../../../../router/all_routes";
/* -- biz9 import start -- */
import {DateTime,Str} from "biz9-utility";
import {Portal_Table,Order_Logic} from "biz9-store";
import {Message,Type,Url,Field,Title} from "../../../../../constant";
import {App,Data,Dashboard,Event,Image,Style,Service_Industry,User,Template,Storage,System} from "../../../../../project";
import {Data_Logic} from "biz9-data-app";
/* -- biz9 import end -- */
const Order_Payment_Edit_Modal = (props) => {
    const [order,setOrder] = useState(props.order);
    const [val_sub_page_title,setValSubPageTitle] = useState("Add Payment");
    const [payment_amounts,setPaymentAmounts] = useState([]);
    const [sel_payment_amount,setSelPaymentAmount] = useState(null);
    useEffect(() => {
        setOrder(props.order);
        get_data(props.order);
            },[props]);
    async function get_data(order) {
        //payment plan
        let payment_plan_4 = order.grand_total /4;
        let payment_plan_3 = order.grand_total /3;
        let payment_plan_2 = order.grand_total /2;
        let payment_plan_1 = order.grand_total /1;
        setPaymentAmounts([
                {id:'ORDER_PAYMENT_PLAN_1', label: "("+Str.get_money(payment_plan_1)+")",value: String(payment_plan_1)},
                {id:')RDER_PAYMENT_PLAN_2', label: "("+Str.get_money(payment_plan_2)+")",value: String(payment_plan_2)},
                {id:')RDER_PAYMENT_PLAN_3', label: "("+Str.get_money(payment_plan_3)+")",value: String(payment_plan_3)},
                {id:')RDER_PAYMENT_PLAN_4', label: "("+Str.get_money(payment_plan_4)+")",value: String(payment_plan_4)},
        ]);
    }
    const updatePaymentAmount = (selectedOption) => {
        setSelPaymentAmount(selectedOption);
    };
    async function btn_post(){
        if(!Str.check_is_null(sel_payment_amount)){
            /*  test - order  - start */
            /*
            let order_payment = Order_Logic.get_order_payment(order.order_number,'test',sel_payment_amount.value);
	        let option = {post_stat:true};
	        let [response,data] = await App_App_Data.post_order(Portal_Url.DATA_POST,{table:Portal_Table.ORDER_PAYMENT,data:order_payment,option:option});
		    if(data){
				window.location.href = all_routes.app_payment_success+"?order_number="+order.order_number;
		    }
            */
            /*  test - order  - end */
        }else{
			window.alert("Select A Payment Amount");
        }
    };
    return (
        <>
        <div className="modal new-modal fade" id="order_payment_edit_modal" data-keyboard="false" data-backdrop="static">
        <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
        <div className="modal-header">
        <h5 className="modal-title">{val_sub_page_title}</h5>
        <button type="button" className="close-btn" data-bs-dismiss="modal">
        <span>×</span>
        </button>
        </div>
        <div className="modal-body">
        <div className="row">
        <div className="col-md-12">
        <div className="amt-wrap">
<div className="form-wrap">
<label className="form-label mb-1 fw-medium text-dark">
Amount
</label>
<Select classNamePrefix="react-select" className="select" styles={Style.customStyles} value={sel_payment_amount} onChange={updatePaymentAmount} placeholder="Choose An Amount" options={payment_amounts} />
</div>
</div>
</div>
<div className="col-md-12">
<Link onClick={btn_post} to="#" data-bs-dismiss="modal" className="btn btn-primary w-100">
Make Payment
</Link>
</div>
</div>
</div>
</div>
</div>
</div>
</>
);
};
export default Order_Payment_Edit_Modal;
